import { Quill } from 'react-quill-new';

const Parchment = Quill.import('parchment');

const DisplayStyle = new Parchment.StyleAttributor('display', 'display', {
  scope: Parchment.Scope.BLOCK,
  whitelist: ['block', 'flex'],
});

export default DisplayStyle;
